export default (value, minimumFractionDigits, maximumFractionDigits) => {
  let options = {};

  const shouldSpecifyFractionDigits = (
    Number.isInteger(minimumFractionDigits)
    && Number.isInteger(maximumFractionDigits)
  );

  if (shouldSpecifyFractionDigits) {
    options = {
      minimumFractionDigits,
      maximumFractionDigits,
    };
  }

  return new Intl.NumberFormat(navigator.language, options).format(value);
};
